import { useEffect, useState } from "react";

const parseDate = (value) => {
  const raw = value.trim();
  if (!raw) return "";
  let day;
  let month;
  let year;
  let match = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (match) {
    [, day, month, year] = match;
  } else {
    match = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    [, year, month, day] = match;
  }
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  if (
    date.getFullYear() !== Number(year)
    || date.getMonth() !== Number(month) - 1
    || date.getDate() !== Number(day)
  ) return null;
  return `${year}-${month}-${day}`;
};

const displayDate = (value) => {
  if (!value) return "";
  const [year, month, day] = value.split("-");
  return `${day}/${month}/${year}`;
};

export const AdminDateField = ({ label, testId, value, onChange }) => {
  const [display, setDisplay] = useState(displayDate(value));

  useEffect(() => {
    setDisplay(displayDate(value));
  }, [value]);

  const update = (nextValue) => {
    setDisplay(nextValue);
    const parsed = parseDate(nextValue);
    if (parsed !== null) onChange(parsed);
  };

  return (
    <label>
      <span className="mb-2 block text-sm font-bold text-slate-700">{label}</span>
      <input
        data-testid={testId}
        value={display}
        onChange={(event) => update(event.target.value)}
        inputMode="numeric"
        placeholder="dd/mm/aaaa"
        className="min-h-[48px] w-full rounded-xl border-2 border-slate-300 px-3 text-base focus:border-emerald-600 focus:outline-none"
      />
    </label>
  );
};